<template>
  <div class="scrollable">
  	<v-header></v-header>
    <div class="content">
    	<div class="breadNav">
        <P>{{$t('m.onlineConsulting.brankNav')}}</P>
      </div>
      <div class="item">
        <div class="tit">
          <p></p>
          <p>健康检查之前：</p>
        </div>
        <div class="msg">
          <p>Q：检查前应少吃、多运动，检查数据才会比较标准？</p>
          <p>A：NO，接受健康检查应以平常心面对，检查前若刻意节食、增加运动，所得的数据反而无法显示身体的真正状况。</p>
          <p>Q：检查前不必禁食8-12小时之久，吃点东西影响不大？</p>
          <p>A：NO，在进食后，食物中的不同成分对检查检验结果产生不同程度的影响。进食后，胆囊收缩，在超声检查、肺部CT时会影响显影，而容易遗漏病变。检查前进食还会影响血糖、血脂肪、肝功能及腹部等项目的检测数据，因此检查前至少要禁食8-12小时。 </p>
          <p>Q：检查前数日，必须开始禁吃动物血和肉类，以免影响粪便检查？</p>
          <p>A：NO，粪便（免疫凝集法）只对人血反应，并不受肉类或动物血的干扰，所以不必禁食。过去会有禁食动物血和肉类的说法，是因为传统的化学检查法，常因受检者在检查前吃了动物血和肉类，因而造成粪便潜血的阳性反应，有鉴于此，爱康特别选择了敏感度高、特异性佳、采样方便的（免疫凝集法），此法只对人血反应，并不受肉类或动物血的干扰。 </p>
          <p>Q：检查前必须中断服药，否则检验结果会受影响？ </p>
          <p>A：NO，慢性病患者在接受健康检查前，仍应继续服用药物，不须中断，其检验数据可作为医生的用药参考。</p>
        </div>
      </div>
      <div class="bottom">
        <p>{{$t('m.onlineConsulting.submit')}}</p>
        <p>{{$t('m.onlineConsulting.or')}}</p>
        <p>{{$t('m.onlineConsulting.phone')}}：400-1234-1234</p>
      </div>
    </div>
  	<v-footer></v-footer>
    
  </div>
</template>

<script>
import axios from 'axios'; 
import {mapActions, mapGetters} from 'vuex';
import header from '../../common/header.vue'  
import footer from '../../common/footer.vue'  
export default {
	name: 'medicalReports',
	data () {
	    return {
	    }
  	},
  	components: {
	    "v-header": header,
	    "v-footer":footer
	  },
  	created() {
  		
    },
  	methods:{
  	},
  	computed: {
  	  // ...mapGetters(['resturantName','resturantId']) // 动态计算属性，相当于this.$store.getters.resturantName
  	}
}
</script>

<style scoped>
  .bottom{
    margin: 30px 0 50px 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .bottom p:nth-child(1){
    width: 180px;
    height: 46px;
    background: #E51E26;
    font-size:16px;
    
    font-weight:600;
    color:#fff;
    line-height:16px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .bottom p:nth-child(2){
    font-size:18px;
    
    font-weight:400;
    color:#333;
    line-height:18px;
    margin-left: 30px;
  }
  .bottom p:nth-child(3){
    font-size:18px;
    
    font-weight:600;
    color:#E51E26;
    line-height:18px;
    margin-left: 30px;
  }
  .item .msg{
    margin-top: 23px;
  }
  .item .msg p{
    font-size:18px;
    
    font-weight:400;
    color:#333;
    line-height:30px;
  }
  .item .tit p:nth-child(1){
    width: 4px;
    height: 18px;
    background: #e94709;
  }
  .item .tit p:nth-child(2){
    font-size:18px;
    
    font-weight:600;
    color:#333;
    line-height:18px;
    margin-left: 7px;
  }
  .item .tit{
    display: flex;
    align-items: center;
  }
  .item{
    width: 1180px;
    margin:0 auto;
    padding: 30px;
    border: 1px solid #ccc;
    margin-top: 30px;
  }
  .breadNav{
    width: 100%;
    height: 80px;
    border-bottom: 2px solid #EAEAEA;
    display: flex;
    align-items: center;
  }
  .breadNav p{
    width: 1180px;
    margin: 0 auto;
    font-size:18px;
    
    font-weight:600;
    color:#333;
    line-height:20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/phyExServices/onlineConsulting/index.vue